// extracted by css-extract-rspack-plugin
export default {"keywordFilter":"jLi7u7mMIAz_WQZX__keywordFilter___"};